import { Link } from "react-router-dom";
import { Sparkles, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-10 h-10 rounded-2xl bg-sky-500 text-white rotate-[-6deg]">
              <Sparkles className="w-5 h-5" />
            </span>
            <span className="font-heading font-extrabold text-2xl text-white">Kwarizmix</span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            La culture numérique pour les élèves de la 3e à la 6e primaire, en accord avec le référentiel FMTTN.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 font-heading">Explorer</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/notre-univers" className="hover:text-sky-400 transition-colors">Notre univers</Link></li>
            <li><Link to="/nos-activites" className="hover:text-sky-400 transition-colors">Nos activités</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 font-heading">Ressources</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/enseignants" className="hover:text-sky-400 transition-colors">Espace enseignants</Link></li>
            <li><Link to="/actualites" className="hover:text-sky-400 transition-colors">Actualités</Link></li>
            <li><Link to="/a-propos" className="hover:text-sky-400 transition-colors">À propos</Link></li>
            <li><Link to="/contact" className="hover:text-sky-400 transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 font-heading">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-sky-400" /> info@kwarizmix.be</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-sky-400" /> Tel. +32 486 211526</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-sky-400" /> 13 Courbevoie, 1348 Louvain-la-Neuve</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Kwarizmix — ASBL KINÉNIUM. Tous droits réservés.</p>
          <p>Mentions légales · BCE 0476.440.046</p>
        </div>
      </div>
    </footer>
  );
}
